import { Link } from 'gatsby';
import { type FC } from 'react';
import { usePathname } from '../../../lib/use-pathname';

import { navLinks } from '../../../data/nav';
import ProductsNav from './product-nav';
import Submenu from './sub-menu';

function isNavActive(pathname: string, href: string): boolean {
  if (href === '/') return pathname === '/';
  return pathname === href || pathname.startsWith(`${href}/`);
}

const LayoutNav: FC = () => {
  const pathname = usePathname();

  return (
    <nav className="site-header__nav hidden lg:flex">
      <ul className="site-header__nav-list">
        <li className="site-header__nav-item">
          <Link
            className={`site-header__nav-link${isNavActive(pathname, '/') ? ' site-header__nav-link--active' : ''}`}
            to="/"
          >
            <span>HOME</span>
          </Link>
        </li>

        <ProductsNav />

        {navLinks.map((link) => {
          if (!link.submenu) {
            return (
              <li className="site-header__nav-item" key={link.name}>
                <Link
                  className={`site-header__nav-link${isNavActive(pathname, link.href) ? ' site-header__nav-link--active' : ''}`}
                  to={link.href}
                >
                  <span>{link.name}</span>
                </Link>
              </li>
            );
          }

          return <Submenu key={link.name} {...link} />;
        })}
      </ul>
    </nav>
  );
};

export default LayoutNav;
